/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useLayoutEffect } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { useAuth } from "../context/auth/AuthContext";
import { getOnboardingResumePath } from "../pages/utils/onboardingSession";
import {
  applyLimitedBack,
  goToLoginScreen,
  locationKey,
  replaceAndLock,
  resetAppHistory,
  shouldLimitBack,
} from "./limitedBackHistory";

function isAuthScreen(pathname) {
  return pathname === "/login" || pathname === "/signup";
}

function isSessionScreen(pathname) {
  return (
    pathname.startsWith("/admin") ||
    pathname === "/company-info" ||
    pathname === "/theme-plan" ||
    pathname.startsWith("/payment") ||
    pathname === "/subscription-payment-result"
  );
}

export default function AppNavigationGuards() {
  const location = useLocation();
  const navigate = useNavigate();
  const navType = useNavigationType();
  const { token, user, authRole, isLoading } = useAuth();
  const loggedIn = Boolean(token && user && authRole);
  const pathname = location.pathname;

  useLayoutEffect(() => {
    if (isLoading) return;

    if (!loggedIn && isSessionScreen(pathname)) {
      goToLoginScreen(navigate);
      return;
    }

    if (loggedIn && isAuthScreen(pathname)) {
      const dest =
        authRole === "superAdmin"
          ? "/admin"
          : authRole === "tenant"
            ? getOnboardingResumePath()
            : "/";
      replaceAndLock(navigate, dest);
      return;
    }

    if (!shouldLimitBack(pathname)) {
      resetAppHistory(locationKey(location));
      return;
    }

    applyLimitedBack(location, navType, navigate);
  }, [isLoading, loggedIn, pathname, authRole, location, navType, navigate]);

  return null;
}
